import { useState } from 'react';

export const useTradeState = () => {
  const [tradeDirection, setTradeDirection] = useState('BUY');
  const [orderType, setOrderType] = useState('MARKET');
  const [stopLossType, setStopLossType] = useState('Fixed');
  const [riskPercent, setRiskPercent] = useState(0.5);
  const [atrMultiplier, setAtrMultiplier] = useState(1.5);
  const [tpMode, setTpMode] = useState('rr_ratio');
  const [rrRatio, setRrRatio] = useState('');
  const [takeProfitValue, setTakeProfitValue] = useState('');

  return {
    tradeDirection,
    setTradeDirection,
    orderType,
    setOrderType,
    stopLossType,
    setStopLossType,
    riskPercent,
    setRiskPercent,
    atrMultiplier,
    setAtrMultiplier,
    tpMode,
    setTpMode,
    rrRatio,
    setRrRatio,
    takeProfitValue,
    setTakeProfitValue,
  };
};
